import classNames from "classnames";
import type React from "react";

type Props = React.HTMLAttributes<HTMLDivElement>;

export default function Legend({ className, ...props }: Props) {
  return (
    <div className={classNames("h-px bg-gray-200", className)} {...props} />
  );
}
